// This piece of code is taken from Vonage own way of checking if end-to-end encryption is supported
export function hasEndToEndEncryptionSupport() {
	let _window$RTCRtpSender, _window$RTCRtpSender2;
	const isCryptoSupported = !!window.crypto;
	const isInsertableStreamsSupported =
		!!(
			(_window$RTCRtpSender = window.RTCRtpSender) != null &&
			(_window$RTCRtpSender.prototype as RTCRtpSender & { createEncodedStreams: unknown }).createEncodedStreams
		) ||
		!!(
			(_window$RTCRtpSender2 = window.RTCRtpSender) != null &&
			(_window$RTCRtpSender2.prototype as RTCRtpSender & { createdEncodedVideoStreams: unknown }).createdEncodedVideoStreams
		);
	const isWebWorkerSupported = !!window.Worker;

	return isCryptoSupported && isInsertableStreamsSupported && isWebWorkerSupported;
}
